import { cn } from '@/shared/utils/cn';
import React from 'react';
import { Checkbox } from '@/modules/Checkbox';

export interface ListItemCheckboxProps {
  title: string;
  description?: string;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
  /** Clases del título; útil con `className` de fila (p. ej. fondo de marca + `ui-text-on-color`). */
  titleClassName?: string;
  /** Si es `true`, no aplica fondo al pasar el ratón (p. ej. listas en popover). @defaultValue false */
  disableHover?: boolean;
}

export const ListItemCheckbox: React.FC<ListItemCheckboxProps> = ({
  title,
  description,
  checked = false,
  disabled = false,
  onChange,
  className,
  titleClassName,
  disableHover = false,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!disabled) {
      onChange?.(!checked);
    }
  };

  return (
    <div
      className={cn(
        'ui-flex ui-gap-8 ui-rounded-control-sm ui-px-8 ui-py-6 ui-transition-all',
        {
          'hover:ui-bg-fill-hover': !disabled && !disableHover,
          'ui-opacity-50': disabled,
        },
        className
      )}
    >
      {/* Checkbox */}
      <div onClick={handleClick} className="ui-flex ui-cursor-pointer ui-items-center">
        <Checkbox
          checked={checked}
          onChange={(val) => onChange?.(val)}
          disabled={disabled}
          size="md"
        />
      </div>

      {/* Content */}
      <div className="ui-flex-1">
        <div
          className={cn(
            'ui-text-body-sm-regular ui-font-body-sm-medium ui-leading-body-sm-regular ui-tracking-body-sm',
            titleClassName ?? 'ui-text-primary'
          )}
        >
          {title}
        </div>
        {description && (
          <div className="ui-text-body-xs-regular ui-font-body-xs-regular ui-leading-body-xs-regular ui-tracking-body-xs ui-text-secondary">
            {description}
          </div>
        )}
      </div>
    </div>
  );
};
